module.exports = __webpack_public_path__ + "img/hotel1_1.8fa22883.png";